<template>
    <div>
        <div class="mr-2" id="search-box">
            <IconField>
              <InputIcon>
                  <i class="pi pi-search" />
              </InputIcon>
              <InputText :placeholder="$t('core.search')" v-model="searchKeyword" />
              <i class="pi pi-times cursor-pointer ml-2" @click="keyword = ''" v-if="keyword !== ''"/>
            </IconField>
            
        </div>
    </div>

</template>

<style scoped lang="scss">
#search-box {
    position: relative;

    svg {
        position: absolute;
        right: 5px;
        top: 10px;
    }
}
</style>

<script setup>
import { ref, computed, watch } from 'vue'
import { useRouter } from 'vue-router'

const show = ref(true)
const keyword = ref('')
const timeout = ref(null)
const result = ref({})
const router = useRouter()

// Debounced setter for keyword
const searchKeyword = computed({
  get: () => keyword.value,
  set: (val) => {
    if (timeout.value) {
      clearTimeout(timeout.value)
    }
    timeout.value = setTimeout(() => {
      keyword.value = val
    }, 300)
  }
})

// Show result if keyword is not empty
const showResult = computed(() => keyword.value !== '')

// Watch keyword and push to router
watch(keyword, (newVal) => {
  router.push({ name: 'system.search', query: { q: newVal } }).catch(() => {})
})
</script>

